var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.734 136.481 344 118.033V96a8 8 0 0 0-5.029-7.428l-36.2-14.48-7.01-28.032A8 8 0 0 0 288 40h-8V16a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v24h-8a8 8 0 0 0-7.761 6.06l-7.008 28.032-36.2 14.48A8 8 0 0 0 168 96v22.033l-50.734 18.448a8 8 0 0 0-5 9.555l39.046 148.384C143.308 306.732 120 352.2 120 464a8 8 0 0 0 8 8h96v24a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-24h96a8 8 0 0 0 8-8c0-111.8-23.308-157.268-31.312-169.58l39.049-148.384a8 8 0 0 0-5.003-9.555ZM328 101.416V104a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16a8 8 0 0 0 0 16v16h-16V112a7.977 7.977 0 0 0-.239-1.94l-4.205-16.822ZM248 24h16v16h-16Zm-64 368h16v16h-16Zm0-290.584 20.444-8.178-4.2 16.822A7.977 7.977 0 0 0 200 112v264h-16v-32a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16v-16a8 8 0 0 0 0-16ZM272 488h-32v-16h32Zm103.958-32H136.042c1.237-118.417 29.789-154.5 30.032-154.794a8 8 0 0 0 1.663-7.242l-38.143-144.941L168 135.058V416a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8V112.985L230.246 56h51.508L296 112.985V368a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-71.922a7.774 7.774 0 0 0 1.874 5.067c.294.355 28.847 36.438 30.084 154.855Zm-31.7-162.036a8.2 8.2 0 0 0-.263 1.82V135.058l38.406 13.965Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer3);
export default __webpack_public_path__ + "static/media/ser-3.d94df0ed1f4f1d9c9658f249f361b019.svg";
export { ForwardRef as ReactComponent };